/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePageVisibility } from "react-page-visibility";
import Push from "push.js";
import {
  clearNotificationOrderInterval,
  setNotificationOrderInterval,
} from "../redux/actions/notificationOrderInterval";
import {
  clearCheckNewOrdersPending,
  getCheckNewOrdersPending,
  refreshTimeStampForCheckNewPending,
} from "../redux/actions/checkNewOrdersPending";
import {
  clearCheckNewCollectOrders,
  getCheckNewCollectOrder,
  refreshTimeStampForCheckNewCollectOrder,
} from "../redux/actions/checkNewCollectOrders";
import { getCollectOrderTabUrl } from "./getCollectOrderTab";
import { setSelectedOrderTab } from "../redux/actions/orders";
import { setSelectedCollectOrderTab } from "../redux/actions/collectionOrderList";

interface ITitle {
  default: string;
  notify: string;
}

const title: ITitle = {
  default: "TradeKart - Portal",
  notify: `New Order`,
};

const intervalDuration: number = 30000;

export const NotificationHandler = () => {
  const dispatch = useDispatch();
  const userLoggedIn = useSelector((state: any) => state.login.userLoggedIn);
  const isCollectEnabled = useSelector(
    (state: any) => state.login.isCollectEnabled
  );
  const isCollectOnly = useSelector((state: any) => state.login.isCollectOnly);
  const role = useSelector((state: any) => state.login.role);
  const [triggerCheckNewOrders, setTriggerCheckNewOrders] = useState(false);
  const [triggerCheckNewCollectOrders] = useState(false);
  const notificationOrderInterval = useSelector(
    (state: any) => state.notificationOrderInterval.interval
  );
  const [selectedTab]: [number] = useSelector((state: any) => [
    state.collectionOrderList.selectedTab,
  ]);

  const [checkNewOrdersPendingData, checkNewOrdersPendingTimeStamp] =
    useSelector((state: any) => [
      state.checkNewOrdersPending.data,
      state.checkNewOrdersPending.timeStamp,
    ]);

  const [checkNewCollectOrdersData, checkNewCollectOrdersTimeStamp] =
    useSelector((state: any) => [
      state.checkNewCollectOrders.data,
      state.checkNewCollectOrders.timeStamp,
    ]);

  const pageVisible = usePageVisibility();
  const onFocus = () => {
    document.title = title.default;
  };

  useLayoutEffect(() => {
    dispatch(setSelectedOrderTab(0));
    dispatch(setSelectedCollectOrderTab(0));
  }, []);

  function onPushClick() {
    window.focus();
    this.close();
  }

  const pushBody = {
    body: "You have a new order.",
    timeout: 4000,
    onClick: onPushClick,
  };

  // Order
  useEffect(() => {
    if (checkNewOrdersPendingData) {
      const audio = new Audio("/new_order_notification.wav");
      audio.load();
      audio.play();
      Push.create("TradeKart - ShopPortal", pushBody);
      document.title = title.notify;
    }
  }, [checkNewOrdersPendingData]);

  // Collect order
  useEffect(() => {
    if (checkNewCollectOrdersData) {
      const audio = new Audio("/new_order_notification.wav");
      audio.load();
      audio.play();
      Push.create("TradeKart - ShopPortal", {
        ...pushBody,
        body: "You have a new collection order",
      });
      document.title = title.notify;
    }
  }, [checkNewCollectOrdersData]);

  const setIntervalForNotification = () => {
    if (!userLoggedIn) {
      return;
    }
    if (pageVisible) {
      let newInterval;
      clearInterval(notificationOrderInterval);
      setTriggerCheckNewOrders((prev) => !prev);
      newInterval = setInterval(() => {
        setTriggerCheckNewOrders((prev) => !prev);
      }, intervalDuration);
      dispatch(setNotificationOrderInterval(newInterval));
    } else {
      clearInterval(notificationOrderInterval);
      dispatch(clearNotificationOrderInterval());
    }
  };

  useEffect(() => {
    if (role) {
      if (!Push.Permission.has()) {
        Push.Permission.request();
      }
      window.addEventListener("focus", onFocus);
      dispatch(refreshTimeStampForCheckNewPending());
      dispatch(refreshTimeStampForCheckNewCollectOrder());
      setIntervalForNotification();
      return () => {
        window.removeEventListener("focus", onFocus);
      };
    }
  }, [role, pageVisible]);

  const getNotifications = () => {
    if (!isCollectOnly) {
      dispatch(clearCheckNewOrdersPending());
      dispatch(getCheckNewOrdersPending(checkNewOrdersPendingTimeStamp));
    }

    if (isCollectEnabled || role === "Admin") {
      dispatch(clearCheckNewCollectOrders());
      const tab = getCollectOrderTabUrl(selectedTab);
      dispatch(getCheckNewCollectOrder(tab, checkNewCollectOrdersTimeStamp));
    }
  };

  useEffect(() => {
    getNotifications();
  }, [triggerCheckNewOrders, triggerCheckNewCollectOrders]);
  return <></>;
};
